// All available games definitions
import { GameConfig } from './types';

// Competitive games (Blitz)
export const TRIVIA: GameConfig = {
  id: 'trivia',
  name: 'Trivia',
  description: 'Test your knowledge with fun trivia questions',
  extendedDescription: 'Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Wrong answers = 0 points • Individual scores tracked on leaderboard',
  icon: '🧠',
  color: '#3B82F6',
  category: 'competitive',
};

export const WORD_PUZZLE: GameConfig = {
  id: 'word-puzzle',
  name: 'Word Puzzle',
  description: 'Find the connection between words',
  extendedDescription: 'Find what connects groups of words • Speed-based scoring system • Faster correct answers = more points • Think quick but stay accurate • Individual scores on leaderboard',
  icon: '🧩',
  color: '#34D399',
  category: 'competitive',
};

export const SPEED_CHALLENGE: GameConfig = {
  id: 'speed-challenge',
  name: 'Speed Challenge',
  description: 'Type fast! Host shows content, players race to type the answer',
  extendedDescription: 'See words, emojis, math & more on screen • Type your answer as fast as you can • 1st place = 100pts, 2nd = 80pts, 3rd = 60pts • Includes reverse words, patterns & color sequences • Fastest fingers win!',
  icon: '⚡',
  color: '#F59E0B',
  category: 'competitive',
  premium: true,
};

export const PICTURE_PERFECT: GameConfig = {
  id: 'picture-perfect',
  name: 'Picture Perfect',
  description: 'Guess famous people, places, and things from images!',
  extendedDescription: 'See an image on screen • Identify famous people, landmarks, and iconic things • Faster correct answers = more points • Full points if answered within first 25% of time • Test your visual knowledge!',
  icon: '📸',
  color: '#EC4899',
  category: 'competitive',
  premium: true,
};

export const CLOSE_OR_NOT: GameConfig = {
  id: 'close-or-not',
  name: 'Close or Not?',
  description: 'Guess the number! Years, counts, distances - the closest wins!',
  extendedDescription: 'Type your best guess for numeric answers • Closer to the correct answer = more points • Perfect answer = 100 points • 1st closest gets +30 bonus, 2nd +20, 3rd +10 • Categories include years, counts, distances, percentages & more!',
  icon: '🎯',
  color: '#F97316',
  category: 'competitive',
  premium: true,
};

export const FACT_OR_MYTH: GameConfig = {
  id: 'fact-or-myth',
  name: 'Fact or Myth',
  description: 'Separate fact from fiction! Decide if statements are fact or myth',
  extendedDescription: 'Fast-paced fact or myth questions with fascinating truths • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Learn interesting facts and debunk myths with each question!',
  icon: '🔍',
  color: '#10B981',
  category: 'competitive',
  premium: true,
};

export const ALMOST_GENIUS: GameConfig = {
  id: 'almost-genius',
  name: 'Almost Genius',
  description: 'Tricky questions designed to catch you off guard',
  extendedDescription: 'Tricky questions designed to catch you off guard • Think carefully and read between the lines • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Test your ability to spot the trap!',
  icon: '🧐',
  color: '#8B5CF6',
  category: 'competitive',
  premium: true,
};

export const PAIR_MATCHING: GameConfig = {
  id: 'pair-matching',
  name: 'Let\'s pair it!',
  description: 'Maybe you pair it all, maybe none, everything counts',
  extendedDescription: 'Match items from two lists to form correct pairs • All pairs correct = 100 points • Partial credit for correct pairs • 1st to get all pairs correct gets +30 bonus • Speed and accuracy both matter • Perfect for testing your knowledge connections!',
  icon: '🧩',
  color: '#06B6D4',
  category: 'competitive',
  premium: true,
};

// Co-op games
export const COLLABORATIVE_PUZZLE: GameConfig = {
  id: 'collaborative-puzzle',
  name: 'Collaborative Puzzle',
  description: 'Work together to solve puzzles, read clues and find the solution',
  extendedDescription: 'Each player receives different clues • Share your clues with the team • Work together to piece together the solution • Communication is key • Everyone wins or loses together',
  icon: '🤝',
  color: '#F59E0B',
  minPlayers: 2,
  category: 'cooperative',
};

export const STORY_CHAIN: GameConfig = {
  id: 'story-chain',
  name: 'Story Chain',
  description: 'Gather all clues to complete the story and find the final answer',
  extendedDescription: 'Each player gets different story clues • Gather all clues together to complete the story • Share information to find the final answer • Team collaboration required • Success depends on everyone',
  icon: '📖',
  color: '#A855F7',
  minPlayers: 2,
  category: 'cooperative',
};

export const BREAK_THE_CODE: GameConfig = {
  id: 'break-the-code',
  name: 'Break the Code',
  description: 'Race the other team — analysts share clues, the breaker enters the code',
  extendedDescription: 'Team vs team code-breaking • Analysts each get private clues • Only the Code Breaker can submit • Rotate breaker each round • Solve as many 4-digit codes as you can • Talk fast!',
  icon: '🔐',
  color: '#EF4444',
  minPlayers: 4,
  category: 'cooperative',
  usesTeams: true,
  minPlayersPerTeam: 2,
};

export const ASSOCIATIONS: GameConfig = {
  id: 'associations',
  name: 'Associations',
  description: 'Explainer describes a secret word — guessers pick among near-misses',
  extendedDescription: 'Team vs team communication • Explainer sees only the word • Guessers see four similar options • One lock-in per team • Rotate explainer each round • Funny when clues fit more than one option!',
  icon: '🎙️',
  color: '#14B8A6',
  minPlayers: 4,
  category: 'cooperative',
  usesTeams: true,
  minPlayersPerTeam: 2,
};

export const CATCH_SHOUT_CATCH: GameConfig = {
  id: 'catch-shout-catch',
  name: 'Catch, Shout, Catch!',
  description: 'Whisperer shouts the target — gatherers catch falling animals!',
  extendedDescription: 'Team vs team coordination • Whisperer sees the target animal • Gatherers catch on their phones • Target changes every 8–12 seconds • Wrong catches score nothing • Rotate whisperer each round!',
  icon: '🎯',
  color: '#F59E0B',
  minPlayers: 4,
  category: 'cooperative',
  usesTeams: true,
  minPlayersPerTeam: 2,
};

export const HOUSE_RUN: GameConfig = {
  id: 'house-run',
  name: 'House Run',
  description: 'Scavenger hunt around the house — photo proof, other team votes!',
  extendedDescription: 'Team vs team real-world hunt • Each team gets a task • Snap a photo as proof • Opposing team votes accept or reject • Accepted tasks score +1 • Race against the clock!',
  icon: '🏃',
  color: '#8B5CF6',
  minPlayers: 2,
  category: 'cooperative',
  usesTeams: true,
  minPlayersPerTeam: 1,
};

export const ONE_BRAIN: GameConfig = {
  id: 'one-brain',
  name: 'One Brain',
  description: 'Share the controls — each teammate moves only some directions!',
  extendedDescription: 'Team vs team maze race • Nobody has full control • Directions split across teammates • Talk fast and reach the exit • Roles rotate each round!',
  icon: '🧠',
  color: '#F97316',
  minPlayers: 4,
  category: 'cooperative',
  usesTeams: true,
  minPlayersPerTeam: 2,
};

// Toyo New pack games
export const DOODLE_HEIST: GameConfig = {
  id: 'doodle-heist',
  name: 'Doodle Heist',
  description: 'Draw a secret prompt, then write fake titles and vote for the real one!',
  extendedDescription:
    'Everyone draws a secret prompt on their phone • Gallery shows each masterpiece on the TV • Write a convincing fake title • Vote for the real one • Fool others for points — or find the truth!',
  icon: '🎨',
  color: '#DB2777',
  minPlayers: 3,
  category: 'party',
};

// Party games
export const DRINKING_GAME: GameConfig = {
  id: 'drinking-game',
  name: 'Drinking Game',
  description: 'Test your booze knowledge! Wrong answers = sips 🍻',
  extendedDescription: 'Answer trivia questions about alcohol, beer, wine & spirits • Wrong answers earn you penalty sips • Everyone sees who needs to drink after each round • The more wrong answers, the more fun! • Play responsibly 🍷',
  icon: '🍺',
  color: '#EC4899',
  minPlayers: 2,
  category: 'party',
};

export const HOT_TAKES: GameConfig = {
  id: 'hot-takes',
  name: 'Hot Takes',
  description: 'Controversial opinions! Vote AGREE or DISAGREE - minority drinks! 🔥',
  extendedDescription: 'Spicy statements appear on screen • Vote AGREE or DISAGREE • Minority group drinks! • Tie = everyone drinks! • Debates encouraged between rounds! • Get ready for some heated discussions 🌶️',
  icon: '🔥',
  color: '#F97316',
  minPlayers: 2,
  category: 'party',
};

export const WOULD_YOU_RATHER: GameConfig = {
  id: 'would-you-rather',
  name: 'Would You Rather',
  description: 'Choose between two awkward options - minority drinks! 🤔',
  extendedDescription: 'Two awkward choices appear on screen • Players choose one option • Minority group drinks! • Tie = everyone drinks! • Perfect for sparking debates and hilarious discussions! • See how your group splits on tough choices 🎯',
  icon: '🤔',
  color: '#A855F7',
  minPlayers: 2,
  category: 'party',
  premium: true,
};

export const ARE_YOU_DRUNK: GameConfig = {
  id: 'are-you-drunk',
  name: 'Are You Drunk?',
  description: 'Can you see clearly? Guess what\'s in the picture! 🍺',
  extendedDescription: 'See an image and guess the answer • Quirky, funny, sexy, and kinky questions • Faster correct answers = more points • Full points if answered within first 25% of time • Perfect for parties with friends! • Are you sober enough to see clearly? 🍻',
  icon: '🍺',
  color: '#EC4899',
  minPlayers: 2,
  category: 'party',
  premium: true,
};

export const RAPID_FIRE: GameConfig = {
  id: 'rapid-fire',
  name: 'Rapid Fire',
  description: 'Lightning-fast true/false questions! Think quick! ⚡',
  extendedDescription: 'Fast-paced true/false questions with fascinating facts • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Learn amazing facts about the world, science, nature & more! • Perfect for parties and quick thinking!',
  icon: '⚡',
  color: '#FBBF24',
  minPlayers: 1,
  category: 'party',
  premium: true,
};

export const STONED_YET: GameConfig = {
  id: 'stoned-yet',
  name: 'Stoned yet?',
  description: 'Cannabis culture trivia for relaxed adult parties',
  extendedDescription: 'Fun trivia about weed, drugs, and stoner culture • Test your knowledge about cannabis, culture, and more • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Perfect for stoners who want to laugh and play!',
  icon: '🌿',
  color: '#10B981',
  minPlayers: 2,
  category: 'party',
  premium: true,
};

export const KINKY_OR_NOT: GameConfig = {
  id: 'kinky-or-not',
  name: 'Kinky or Not?',
  description: 'Spicy true-or-false questions about sex and relationships',
  extendedDescription: 'Kinky, embarrassing, sexy, tempting, steamy, spicy questions • Test your knowledge about relationships, sex, and kink • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Perfect for adult parties and spicy conversations!',
  icon: '🔥',
  color: '#EC4899',
  minPlayers: 2,
  category: 'party',
  premium: true,
};

export const PLAY_IT_LOUD: GameConfig = {
  id: 'play-it-loud',
  name: 'Play it Loud',
  description: 'Let\'s burn those speakers',
  extendedDescription: 'Music trivia with images! Identify artists, songs, and albums • Covers Pop, Hip-Hop, Rock, Latin, EDM, R&B, Country, K-Pop, Afrobeats, Phonk, Classical, Metal, Reggae, Jazz, Blues, Punk, Folk, Funk, Lo-fi, and Soundtracks • Answer quickly and correctly to earn points • Faster correct answers = more points • Full points if answered within first 25% of time • Perfect for music lovers!',
  icon: '🎵',
  color: '#8B5CF6',
  minPlayers: 2,
  category: 'party',
  premium: true,
};

export const PARTY_PAIR_MATCHING: GameConfig = {
  id: 'party-pair-matching',
  name: 'Let\'s pair it!',
  description: 'Maybe you pair it all, maybe none, everything counts',
  extendedDescription: 'Match items from two lists to form correct pairs • All pairs correct = 100 points • Partial credit for correct pairs • 1st to get all pairs correct gets +30 bonus • Speed and accuracy both matter • Perfect for testing your knowledge connections!',
  icon: '🧩',
  color: '#06B6D4',
  minPlayers: 1,
  category: 'party',
  premium: true,
};

// Team games (business/teambuilding)
export const AGILE_QUIZ: GameConfig = {
  id: 'agile-quiz',
  name: 'Agile Quiz',
  description: 'Test your Scrum, Kanban & IT knowledge!',
  extendedDescription: 'Questions about Scrum, Kanban, sprint ceremonies & agile methodologies • Mix of serious and satirical IT/business questions • Individual scores + team average bonus • Great for onboarding, retros, and team fun!',
  icon: '📋',
  color: '#3B82F6',
  category: 'competitive',
};

export const TECH_TRIVIA: GameConfig = {
  id: 'tech-trivia',
  name: 'Tech Trivia',
  description: 'Identify tech logos, pioneers & inventions!',
  extendedDescription: 'See images of tech logos, pioneers, and inventions • When was the iPhone released? Who founded Microsoft? • Identify programming languages, companies & tech history • Speed-based scoring • Perfect for dev teams & tech enthusiasts!',
  icon: '💻',
  color: '#06B6D4',
  category: 'competitive',
};

export const BUSINESS_BRAIN_TEASERS: GameConfig = {
  id: 'business-brain-teasers',
  name: 'Business Brain Teasers',
  description: 'Test your business knowledge! Leaders, companies & culture',
  extendedDescription: 'Questions about business leaders, company history, innovation & workplace culture • Who founded Amazon? What\'s a unicorn startup? • Learn about famous quotes, failures & success stories • Speed-based scoring • Perfect for team building & business enthusiasts!',
  icon: '🧠',
  color: '#8B5CF6',
  category: 'competitive',
  premium: true,
};

export const ITS_FUNNY: GameConfig = {
  id: 'its-funny',
  name: 'It\'s funny!',
  description: 'True stories from office life — laugh, then answer',
  extendedDescription: 'Funny but true questions about office life, meetings, and workplace culture • Laugh at the realities of corporate life • Answer quickly and correctly to earn points • Faster correct answers = more points • Perfect for team building and office humor!',
  icon: '😄',
  color: '#F59E0B',
  category: 'competitive',
  premium: true,
};

export const BEFORE_OR_AFTER: GameConfig = {
  id: 'before-or-after',
  name: 'Before or After',
  description: 'Show one event, ask what came before or after',
  extendedDescription: 'Questions about historical events, technology, and innovations • What happened BEFORE the smartphone? What came AFTER the internet? • Test your knowledge of chronological order • Works great for history & tech • Speed-based scoring • Perfect for team building!',
  icon: '⏰',
  color: '#10B981',
  category: 'competitive',
  premium: true,
};

export const TEAM_PAIR_MATCHING: GameConfig = {
  id: 'team-pair-matching',
  name: 'Let\'s pair it!',
  description: 'Maybe you pair it all, maybe none, everything counts',
  extendedDescription: 'Match items from two lists to form correct pairs • All pairs correct = 100 points • Partial credit for correct pairs • 1st to get all pairs correct gets +30 bonus • Speed and accuracy both matter • Perfect for testing your knowledge connections!',
  icon: '🧩',
  color: '#06B6D4',
  category: 'competitive',
  premium: true,
};

// What could it be? – Blitz (catchy name for blitz pack)
export const WHAT_COULD_IT_BE: GameConfig = {
  id: 'what-could-it-be',
  name: 'What could it be?',
  description: 'Clues drop every few seconds — type your guess fast',
  extendedDescription: 'Clues appear every 3 seconds • Type your answer—the fewer clues you need, the more points you get • 1 clue = 100 pts, 2 = 75, 3 = 50, 4 = 25, 5 = 10 • Fast, funny, and addictive!',
  icon: '🔮',
  color: '#A855F7',
  category: 'competitive',
  premium: true,
};

// Clue in! – Team (business/agile/IT)
export const CLUE_IN: GameConfig = {
  id: 'clue-in',
  name: 'Clue in!',
  description: 'Business and tech clues reveal one by one — guess before time runs out',
  extendedDescription: 'Clues appear every 3 seconds • Type your answer—the fewer clues you need, the more points you get • 1 clue = 100 pts, 2 = 75, 3 = 50, 4 = 25, 5 = 10 • Business, agile, and tech themed!',
  icon: '💡',
  color: '#3B82F6',
  category: 'competitive',
  premium: true,
};

// What am I? – Family (all ages, easy)
export const WHAT_AM_I: GameConfig = {
  id: 'what-am-i',
  name: 'What am I?',
  description: 'Family-friendly clues reveal slowly — shout your guess',
  extendedDescription: 'Clues appear every 3 seconds • Type your answer—the fewer clues you need, the more points you get • 1 clue = 100 pts, 2 = 75, 3 = 50, 4 = 25, 5 = 10 • Family-friendly and fun for all ages!',
  icon: '👨‍👩‍👧‍👦',
  color: '#F97316',
  category: 'competitive',
  premium: true,
};

// How Many? – Family (numeric guessing, closest wins)
export const HOW_MANY: GameConfig = {
  id: 'how-many',
  name: 'How Many?',
  description: 'Guess the number! Legs, conversions, counts — closest wins!',
  extendedDescription: 'Type your best guess for numeric answers • Closer to the correct answer = more points • Perfect answer = 200 points • 1st closest gets +30 bonus, 2nd +20, 3rd +10 • Animals, science, math & more — fun for all ages!',
  icon: '🔢',
  color: '#F97316',
  category: 'competitive',
  premium: true,
};

// Let's pair it! – Family (family-friendly matching)
export const FAMILY_PAIR_MATCHING: GameConfig = {
  id: 'family-pair-matching',
  name: "Let's pair it!",
  description: 'Maybe you pair it all, maybe none, everything counts',
  extendedDescription: 'Match items from two lists to form correct pairs • All pairs correct = 100 points • Partial credit for correct pairs • 1st to get all pairs correct gets +30 bonus • Family-friendly questions for all ages!',
  icon: '🧩',
  color: '#06B6D4',
  category: 'competitive',
  premium: true,
};

// Guess what! – Party (funny, catchy, drinking)
export const GUESS_WHAT: GameConfig = {
  id: 'guess-what',
  name: 'Guess what!',
  description: 'Party clues drop in — fewer clues means more points',
  extendedDescription: 'Clues appear every 3 seconds • Type your answer—the fewer clues you need, the more points you get • 1 clue = 100 pts, 2 = 75, 3 = 50, 4 = 25, 5 = 10 • Funny, catchy, and perfect for parties!',
  icon: '🎉',
  color: '#EC4899',
  category: 'party',
  minPlayers: 2,
  premium: true,
};

// Family games
export const FAMILY_TRIVIA: GameConfig = {
  id: 'family-trivia',
  name: 'Family Trivia',
  description: 'Age-appropriate fun for the whole family!',
  extendedDescription: 'Age-appropriate questions: 5-8, 9-12, teens, or mixed • Categories: Animals, Space, Disney, Science & more • Gentle scoring - everyone feels like a winner! • Perfect for family game night',
  icon: '👨‍👩‍👧‍👦',
  color: '#F97316',
  category: 'competitive',
};

export const ANIMAL_QUIZ: GameConfig = {
  id: 'animal-quiz',
  name: 'Animal Quiz',
  description: 'Identify amazing animals from photos!',
  extendedDescription: 'See beautiful animal photos • Identify species from around the world • Learn fun facts about wildlife • Educational and entertaining • Kids love it!',
  icon: '🐾',
  color: '#A855F7',
  category: 'competitive',
};

export const WONDER_WORLD: GameConfig = {
  id: 'wonder-world',
  name: 'Wonder World',
  description: 'Discover amazing facts about our incredible world!',
  extendedDescription: 'Learn fascinating facts about nature, space, animals, and more • Spark curiosity and conversation • Family-friendly fun for all ages • Educational and entertaining • Perfect for family game night!',
  icon: '🌍',
  color: '#10B981',
  category: 'competitive',
  premium: true,
};

// Game collections
export const BLITZ_GAMES: GameConfig[] = [TRIVIA, WORD_PUZZLE, SPEED_CHALLENGE, PICTURE_PERFECT, CLOSE_OR_NOT, FACT_OR_MYTH, ALMOST_GENIUS, PAIR_MATCHING, WHAT_COULD_IT_BE];
export const COOP_GAMES: GameConfig[] = [BREAK_THE_CODE, ASSOCIATIONS, CATCH_SHOUT_CATCH, HOUSE_RUN, ONE_BRAIN];
export const PARTY_GAMES: GameConfig[] = [DRINKING_GAME, HOT_TAKES, ARE_YOU_DRUNK, RAPID_FIRE, WOULD_YOU_RATHER, STONED_YET, KINKY_OR_NOT, PLAY_IT_LOUD, PARTY_PAIR_MATCHING, GUESS_WHAT];
export const TEAM_GAMES: GameConfig[] = [AGILE_QUIZ, TECH_TRIVIA, BUSINESS_BRAIN_TEASERS, ITS_FUNNY, BEFORE_OR_AFTER, TEAM_PAIR_MATCHING, CLUE_IN];
export const FAMILY_GAMES: GameConfig[] = [FAMILY_TRIVIA, ANIMAL_QUIZ, WONDER_WORLD, WHAT_AM_I, FAMILY_PAIR_MATCHING, HOW_MANY];
export const NEW_GAMES: GameConfig[] = [DOODLE_HEIST];
export const ALL_GAMES: GameConfig[] = [...BLITZ_GAMES, ...COOP_GAMES, ...PARTY_GAMES, ...TEAM_GAMES, ...FAMILY_GAMES, ...NEW_GAMES];

